import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField,
  Typography, Box, MenuItem, Select, FormControl, InputLabel, Chip } from "@mui/material";

const token = () => localStorage.getItem("biyz_token");
const authHead = () => ({ Authorization: `Bearer ${token()}`, "Content-Type": "application/json" });

const CEFR_LEVELS = [
  { value: "A1", label: "A1 — Başlangıç" },
  { value: "A2", label: "A2 — Temel" },
  { value: "B1", label: "B1 — Orta Altı" },
  { value: "B2", label: "B2 — Orta Üstü" },
  { value: "C1", label: "C1 — İleri" },
  { value: "C2", label: "C2 — Uzman" },
];

export default function OnboardingModal({ me }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ age: "", city: "", occupation: "", cefrLevel: "", targetExam: "" });
  const [loading, setLoading] = useState(false);

  // Sunucudaki onboardingDone bayrağı esastır — sadece ilk girişte sorulur
  useEffect(() => {
    if (!me || !localStorage.getItem("biyz_token")) return;
    if (me.onboardingDone) {
      localStorage.setItem("onboarding_done", "1");
      return;
    }
    if (localStorage.getItem("onboarding_done")) {
      // Eski localStorage cevabını sunucuya taşı, tekrar sorma
      markDone();
      return;
    }
    const t = setTimeout(() => setOpen(true), 2000);
    return () => clearTimeout(t);
  }, [me]);

  const markDone = async (extra = {}) => {
    try {
      await fetch("/api/platform/users/me", {
        method: "PUT",
        headers: authHead(),
        body: JSON.stringify({ onboardingDone: true, ...extra }),
      });
    } catch {}
    localStorage.setItem("onboarding_done", "1");
  };

  const handleSkip = async () => {
    setOpen(false);
    await markDone();
  };

  const handleSave = async () => {
    setLoading(true);
    await markDone({
      age: form.age ? Number(form.age) : undefined,
      city: form.city || undefined,
      occupation: form.occupation || undefined,
      cefrLevel: form.cefrLevel || undefined,
      targetExam: form.targetExam || undefined,
    });
    setLoading(false);
    setOpen(false);
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle>
        Profilinizi Tamamlayın
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          Bu bilgiler botların size daha iyi yardımcı olmasını sağlar. İstediğiniz alanı boş bırakabilirsiniz.
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField fullWidth label="Yaş" type="number" size="small" value={form.age} onChange={set("age")} />
            <TextField fullWidth label="Şehir" size="small" value={form.city} onChange={set("city")} />
          </Box>
          <TextField fullWidth label="Meslek" size="small" value={form.occupation} onChange={set("occupation")} />
          <FormControl fullWidth size="small">
            <InputLabel>Dil Seviyeniz</InputLabel>
            <Select value={form.cefrLevel} label="Dil Seviyeniz" onChange={set("cefrLevel")}>
              <MenuItem value=""><em>Seçiniz</em></MenuItem>
              {CEFR_LEVELS.map(l => <MenuItem key={l.value} value={l.value}>{l.label}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField fullWidth label="Hedef Sınav (IELTS, TOEFL, YDS...)" size="small"
            value={form.targetExam} onChange={set("targetExam")} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSkip} color="inherit">Şimdi Değil</Button>
        <Button variant="contained" onClick={handleSave} disabled={loading}>Kaydet</Button>
      </DialogActions>
    </Dialog>
  );
}
